import React from 'react'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { useCookieConsentStore, hasAnalyticsConsent, hasPerformanceConsent } from '@/stores/cookieConsentStore'

export function ConditionalAnalytics() {
  const { consent } = useCookieConsentStore()

  // Don't render anything if no consent has been given yet
  if (!consent) {
    return null
  }

  return (
    <>
      {/* Only load Analytics if user has consented to analytics cookies */}
      {hasAnalyticsConsent() && <Analytics />}
      
      {/* Only load Speed Insights if user has consented to performance cookies */}
      {hasPerformanceConsent() && <SpeedInsights />}
    </>
  )
}

// Helper hook to check if analytics should be enabled
export function useAnalyticsEnabled() {
  const { consent } = useCookieConsentStore()
  return consent?.analytics ?? false
}

// Helper hook to check if performance monitoring should be enabled
export function usePerformanceEnabled() {
  const { consent } = useCookieConsentStore()
  return consent?.performance ?? false
}

// Helper function to safely track events (only if analytics is enabled)
export function trackEvent(eventName: string, properties?: Record<string, any>) {
  if (hasAnalyticsConsent()) {
    // You can add custom analytics tracking here if needed
    console.log('Event tracked:', eventName, properties)
  }
}

// Helper function to safely log performance data (only if performance is enabled)
export function logPerformance(metricName: string, value: number, unit: string = 'ms') {
  if (hasPerformanceConsent()) {
    // You can add custom performance logging here if needed
    console.log('Performance metric:', metricName, value, unit)
  }
}
